<template>
  <li class="dropdown_menu" :class="mainExamListCssObj">
    <a v-b-toggle.livesCollapse>
      <b-icon-camera-video-fill />

      <span class="link-title menu_hide ml-1">Live</span>
      <span class="fa arrow menu_hide"></span>
    </a>
    <b-collapse id="livesCollapse" :visible="false" accordion="accordion">
      <main-collapse-menu
        :collapse-list="collapseList"
        :is-active="!isActive"
      />
    </b-collapse>
  </li>
</template>

<script>
import MainCollapseMenu from "@/components/layouts/sidebars/collapse-menu/MainCollapseMenu.vue";
import _ from "lodash";
import authMixin from "@/mixins/auth-mixin.js";
import { checkSubMenuAccess } from "../../../../services/accessControl";

export default {
  components: {
    MainCollapseMenu,
  },
  mixins: [authMixin],
  data() {
    return {
      isActive: false,
      collapseList: [],
    };
  },
  computed: {
    mainExamListCssObj() {
      return {
        active: this.isActive,
      };
    },
  },
  watch: {},
  mounted() {
    if (checkSubMenuAccess({ menu: "live-mgmt" }, this.getCurrentUser())) {
      this.collapseList.push({
        title: "จัดการ Live",
        to: {
          name: "live.index",
        },
      });
    }
  },
  methods: {
    checkActiveRoute() {
      const useModuleMetaMatcher = !!this.$route.meta.module;
      this.isActive = _.includes(
        _.map(this.collapseList, (ech) => {
          if (!!ech.meta && !!ech.meta.module) {
            return ech.meta.module;
          }
          return ech.to.name;
        }),
        useModuleMetaMatcher ? this.$route.meta.module : this.$route.name
      );
    },
  },
};
</script>
